export const pdOne={
    id:'product-1',
    gal1: require('../../images/gallery-1-1.jpg').default,
    gal2: require('../../images/gallery-1-2.webp').default,
    gal3: require('../../images/gallery-1-3.jpg').default,
    gal4: require('../../images/gallery-1-4.webp').default,
    description: 'Navy blue solid sweat jacket, Slim fit, Full-zip closure, Long sleeves, Side zip pockets for storage solution, Ribbed cuffs and collar, Curved cutlines, Mercedes-AMG Petronas Motorsport Logo at right chest, PUMA Cat Logo at left chest',
    name: 'PUMA Motorsport',
    title: 'Men Navy Blue Mercedes F1 Slim Fit Sweat Jacket',
    ra:'4.3 ',
    price: 'Rs. 5999'
};

export const pdTwo={
    id:'product-2',
    gal1: require('../../images/gallery-2-1.webp').default,
    gal2: require('../../images/gallery-2-2.webp').default,
    gal3: require('../../images/gallery-2-3.webp').default,
    gal4: require('../../images/gallery-2-4.webp').default,
    description: 'Off-White solid sporty jacket, has a hooded, 2 pockets, zip closure, long sleeves, straight hem, mesh lining',
    name: 'HRX by Hrithik Roshan',
    title: 'Men Off-White Solid Sporty Jacket',
    ra:'4.5 ',
    price: 'Rs. 1199'
}
export const pdThree={
    id:'product-3',
    gal1: require('../../images/gallery-3-1.webp').default,
    gal2: require('../../images/gallery-3-2.webp').default,
    gal3: require('../../images/gallery-3-3.webp').default,
    gal4: require('../../images/gallery-3-4.webp').default,
    description: 'A COMFORTABLE TRACK SUIT STYLED FOR EVERYDAY WEAR A great style or workout choice, this Cotton fleece tracksuit will move with your body and provide you warmth Jacket and pants with open pockets for storage Internal drawcord in pant for adjustable fit. Zipper pocket in front for added style',
    name: 'Reebok',
    title: 'Men Black Solid Training TRACKSUIT',
    ra: '4.4 ',
    price: 'Rs. 3999'
};
export const pdFour={
    id:'product-4',
    gal1: require('../../images/gallery-4-1.jpg').default,
    gal2: require('../../images/gallery-4-2.jpg').default,
    gal3: require('../../images/gallery-4-3.jpg').default,
    gal4: require('../../images/gallery-4-4.webp').default,
    description: 'Grey solid training jacket Has a hood, 2 pockets, Zip closure, Long sleeves, Straight hem, Mesh lining, Warranty: 3 months from the date of purchase against manufacturing defects',
    name: 'ADIDAS',
    title: 'Men Grey MT Full Zip Hooded Training Jacket',
    ra: '4.7 ',
    price: 'Rs. 3009'
};
export const pdFive={
    id:'product-5',
    gal1: require('../../images/gallery-5-1.webp').default,
    gal2: require('../../images/gallery-5-2.webp').default,
    gal3: require('../../images/gallery-5-3.webp').default,
    gal4: require('../../images/gallery-5-4.webp').default,
    description: 'Blue solid casual shirt, has a spread collar, button placket, and curved hem',
    name: 'Allen Solly',
    title: 'Men Blue Slim Fit Solid Casual Shirt',
    ra: '4.8 ',
    price: 'Rs. 1499'
};
export const pdSix={
    id:'product-6',
    gal1: require('../../images/gallery-6-1.jpg').default,
    gal2: require('../../images/gallery-6-2.webp').default,
    gal3: require('../../images/gallery-6-3.jpg').default,
    gal4: require('../../images/gallery-6-4.webp').default,
    description: 'Black printed sweatshirt, has a hood, long sleeves, straight hem',
    name: 'WROGN',
    title: 'Men Black Printed Hooded Sweatshirt',
    ra: '4.2 ',
    price: 'Rs. 1199'
};
export const pdSeven={
    id:'product-7',
    gal1: require('../../images/gallery-7-1.webp').default,
    gal2: require('../../images/gallery-7-2.jpg').default,
    gal3: require('../../images/gallery-7-3.webp').default,
    gal4: require('../../images/gallery-7-4.webp').default,
    description: 'Multi-coloured a-line top. Ethnic motifs print, Round neck, Three-quarter bell sleeves, Gathered or pleated detail Woven',
    name: 'Azira',
    title: 'Multicoloured Ethnic Motifs Print Bell Sleeves A-Line Top',
    ra: '4.2 ',
    price: 'Rs. 695'
};
export const pdEight={
    id:'product-8',
    gal1: require('../../images/gallery-8-1.webp').default,
    gal2: require('../../images/gallery-8-2.webp').default,
    gal3: require('../../images/gallery-8-3.webp').default,
    gal4: require('../../images/gallery-8-4.webp').default,
    description: 'White solid woven regular top, has a square neck, long sleeves, and zip closure',
    name: 'Harpa',
    title: 'Women White Solid Top',
    ra: '4 ',
    price: 'Rs. 629'
};
export const pdNine={
    id:'product-9',
    gal1: require('../../images/gallery-9-1.jpg').default,
    gal2: require('../../images/gallery-9-2.webp').default,
    gal3: require('../../images/gallery-9-3.jpg').default,
    gal4: require('../../images/gallery-9-4.jpg').default,
    description: 'White conversational printed casual shirt, has a spread collar, button placket, 1 patch pocket, long regular sleeves, curved hem',
    name: 'M&H Juniors',
    title: 'Boys White Slim Fit Pure Cotton Conversational Printed Casual Shirt',
    ra: '4.6 ',
    price: 'Rs. 839'
};
export const pdTen={
    id:'product-10',
    gal1: require('../../images/gallery-10-1.webp').default,
    gal2: require('../../images/gallery-10-2.jpg').default,
    gal3: require('../../images/gallery-10-3.webp').default,
    gal4: require('../../images/gallery-10-4.webp').default,
    description: 'When in doubt, rock this simple yet stylish kurta set at any traditional function. It comes with an elegant printed kurta and snug printed palazzos for comfort.',
    name: 'Ahalyaa',
    title: 'Women Beige Floral Printed Regular Gotta Patti Kurta with Palazzos & With Dupatta',
    ra: '4 ',
    price: 'Rs. 839'
};
export const pdEleven={
    id:'product-11',
    gal1: require('../../images/gallery-11-1.webp').default,
    gal2: require('../../images/gallery-11-2.webp').default,
    gal3: require('../../images/gallery-11-3.jpg').default,
    gal4: require('../../images/gallery-11-4.webp').default,
    description: 'Blue and white yoke design A-line kurti , has a tie-up neck, three-quarter sleeves, flared hem',
    name: 'all about you',
    title: 'Women Blue & White Printed Kurti',
    ra: '4.5 ',
    price: 'Rs. 899'
};
export const pdTwelve={
    id:'product-12',
    gal1: require('../../images/gallery-12-1.webp').default,
    gal2: require('../../images/gallery-12-2.webp').default,
    gal3: require('../../images/gallery-12-3.webp').default,
    gal4: require('../../images/gallery-12-4.webp').default,
    description: 'Navy Blue solid woven regular top, has a tie-up neck, long sleeves, and tie-ups closure.',
    name: 'Cutiekins',
    title: 'Girls Navy Blue Solid Top',
    ra: '4 ',
    price: 'Rs. 417'
};
export const pdThirteen={
    id:'product-13',
    gal1: require('../../images/gallery-13-1.webp').default,
    gal2: require('../../images/gallery-13-2.webp').default,
    gal3: require('../../images/gallery-13-3.webp').default,
    gal4: require('../../images/gallery-13-4.webp').default,
    description: 'Turquoise blue and pink embroidered lehenga choli with dupatta, thread work. Turquoise blue and pink embroidered unstitched blouse, has a round neck, short sleeves, turquoise blue and pink embroidered ready to wear lehenga, has slip-on closure, flared hem Turquoise blue and pink embellished dupatta, solid border',
    name: 'Fab',
    title: 'Turquoise Blue & Pink Embroidered Thread Work Ready to Wear Lehenga & Unstitched Blouse With',
    ra: '4 ',
    price: 'Rs. 3359'
};
export const pdFourteen={
    id:'product-14',
    gal1: require('../../images/gallery-14-1.webp').default,
    gal2: require('../../images/gallery-14-2.webp').default,
    gal3: require('../../images/gallery-14-3.webp').default,
    gal4: require('../../images/gallery-14-4.webp').default,
    description: 'White self design puffer jacket, has a mock collar, 2 pockets, zip closure, long sleeves, straight hem',
    name: 'Roadster',
    title: 'Women White Self Design Puffer Jacket',
    ra: '4.1 ',
    price: 'Rs. 1304'
};